import {createGAEvent} from '@optimaxdev/analytics/desktop/lib/gaEvent/index';
import {pushDataLayer} from '@optimaxdev/analytics/desktop/lib/pushDataLayer/index';

import {CHECKOUT_DELIVERY_STEP} from 'constants/analytics/events/checkout';

import {CHECKBOX_STATUS} from '../../constants/checkout';
import {PAYMENTS} from '../../constants/paymentStep';

import {managerNewsletterSubscription} from './managerNewsletterSubscription';
/**
 * Subscription analytic handler
 */
export const handleSubscriptionAnalytics = (message: string): void => {
    const {isChecked, isVisible} = managerNewsletterSubscription.getData();

    let promState = CHECKBOX_STATUS.CHECKED;
    if (!isVisible) promState = CHECKBOX_STATUS.UNSEEN;
    if (!isChecked) promState = CHECKBOX_STATUS.UNCHECKED;

    pushDataLayer({
        ...createGAEvent(CHECKOUT_DELIVERY_STEP, {
            message,
            version: 'D',
        }),
        EmailPromotionState: promState,
    });
};

/**
 * Check user status and payment method
 */
export const checkPaymentEvent = (): boolean => {
    return managerNewsletterSubscription.getSubscriptionStatus() === 'UNKNOWN';
};

/**
 * Check user status and payment method
 */
export const checkAmazonEvent = (namePaymentMethod: string): boolean => {
    return (
        checkPaymentEvent() &&
        managerNewsletterSubscription.getEnabledForLocation() &&
        namePaymentMethod === PAYMENTS.METHOD_AMAZON_V2
    );
};
